import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Mail } from 'lucide-react';
import { AnimatedSection } from '../shared/AnimatedSection';

export function AboutCTA() {
  return (
    <section className="py-20 bg-white text-zwheel-black relative overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-zwheel-gray-900 rounded-full -translate-x-48 -translate-y-48"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-zwheel-gray-900 rounded-full translate-x-32 translate-y-32"></div>
      </div>

      <div className="container-max section-padding relative z-10">
        <AnimatedSection>
          <motion.div
            className="text-center max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Únete a la revolución eléctrica
            </h2>
            <p className="text-xl md:text-2xl text-zwheel-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
              Forma parte de nuestra comunidad y descubre cómo ZWheel está transformando la movilidad urbana.
            </p>

            {/* CTA 按钮组 */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              {/* 主要行动按钮 - 加入社区 */}
              <Link to="/contacto">
                <motion.button
                  className="group bg-black text-white px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 hover:shadow-xl hover:shadow-black/30 hover:bg-gray-900"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span className="flex items-center">
                    <Users className="mr-2 h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
                    Únete a nosotros
                  </span>
                </motion.button>
              </Link>

              {/* 次要行动按钮 - 联系我们 */}
              <Link to="/contacto">
                <motion.button
                  className="group bg-white border-2 border-gray-300 text-gray-700 px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 hover:shadow-xl hover:shadow-gray-200 hover:border-gray-900 hover:text-gray-900 hover:bg-gray-50"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <span className="flex items-center">
                    <Mail className="mr-2 h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
                    Envíanos un mensaje
                  </span>
                </motion.button>
              </Link>
            </div>

            {/* 附加信息 */}
            <div className="mt-12 text-zwheel-gray-500 text-sm">
              <p>✓ Comunidad activa  ✓ Eventos exclusivos  ✓ Novedades y actualizaciones</p>
            </div>
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
}
